class Technology {
    constructor(name, link) {
        this.name = name // string
        this.link = link // string
    }
}

export default Technology